<template>
  <div class="form-text">
    <ion-item>
      <ion-textarea :value="computedValue" @input="handleInput"></ion-textarea>
    </ion-item>
  </div>
</template>

<script>
export default {
  name: "FormText",
  props: {
    value: String,
    properties: Object
  },
  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },
  methods: {
    handleInput(e) {
      const value = e.target.value;
      this.computedValue = value;
    }
  }
};
</script>
